import { Controller } from "@hotwired/stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ['fileInput']
  static values = {
    settingsUrl: String,
    url: String
  }

  uploadCoverImage() {
    this.disableButton()

    axios.post(this.urlValue, {
      filename: "covers/custom_cover_image.jpg"
    })
    .then(response => this.uploadFileToRackspace(response.data))
    .then(response => this.updateCoverImageFlag(response.data))
    // We want the new cover image to show up, so the easiest way is to just reload the page.
    .then(_response => window.location.reload())
    .catch(error => console.warn(error))
    .then(_response => this.enableButton())
  }

  uploadFileToRackspace(uploadUrl) {
    return new Promise((resolve, reject) => {
      const uploadFile = this.fileInputTarget.files[0];
      let reader = new FileReader();

      reader.onload = () => {
        resolve(
          axios.request({
            headers: {
              "Content-Type": uploadFile.type,
              "X-Detect-Content-Type": "true"
            },
            method: "PUT",
            data: reader.result,
            url: uploadUrl
          })
        )
      }
      reader.onerror = () => { reject(/*...*/) }
      reader.readAsArrayBuffer(uploadFile)
    })
  }

  updateCoverImageFlag() {
    return axios.put(this.settingsUrlValue, {
      video: { custom_cover_image: true }
    })
  }

  disableButton() { this.element.classList.add('is--loading') }
  enableButton() { this.element.classList.remove('is--loading') }
}
